// @flow
import ProductListFooter from './ProductListFooter';

export default ProductListFooter;
